import React from 'react';
import Status from '../components/Status';
import { colors } from '../constants/colors';

// Ð¡Ð´ÐµÐ»ÐºÐ°, Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½Ð°Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼ Ð¸Ð· Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ, Ð¿Ð¾Ð¼ÐµÑÐµÐ½Ð° Ð² ÑÐ¿Ð¸ÑÐºÐµ; Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ Ð¿ÑÑÑÐ¾.
export const dealSourceLabel = (row) =>
  row?.source === 'app' ? <Status status="ÐÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ" color={colors.dimGray} /> : null;
